import GenericService from './GenericService';

export default class MunicipioService extends GenericService {

    constructor(){
        super('/api/municipios')
    }
}